import script from "./Cards.vue?vue&type=script&lang=ts&setup=true"
export * from "./Cards.vue?vue&type=script&lang=ts&setup=true"

import "./Cards.vue?vue&type=style&index=0&id=68864fe7&lang=less"

const __exports__ = script;

export default __exports__